define('modules/editor/behaviours/has_elements',['require','exports','module','backbone'],function(require, exports, module) {

  var Backbone = require("backbone");
      //ElementsCollection = require("../collections/elements");

  module.exports = {
    /**
     * Returns the number of elements in this section
     * @return {integer}
     */
    getElementCount: function(){
      return this.elements.length;
    },
    getElementById: function(id){
      return this.getIdProp() === id || this.elements.reduce(function(acc, element){
        return element.getElementById(id) || acc;
      }, undefined);
    },
    getHighestId: function() {
      function parseId(element){
        var prop = element.getPropertyGroup("idclass").get("id"),
            id = +(prop.split("-").pop());
        return isNaN(id)? 0 : id;
      }

      return this.elements.reduce(function(id, element){
        var hid = (element.getHighestId && element.getHighestId()) || parseId(element);
        return Math.max(id, hid);
      }, parseId(this));
    },
    /**
     * Adds an element to this Section
     * @param {Model} element New element's model
     */
    addElement: function(element) {
      if (!element) return;
      //by default, add to end (top of the section)
      element.set("displayOrder", this.elements.length);
      this.elements.add(element);
      //notify the element it's been added
      element.triggerMethod("add");
      //bubble up add:element event through the sections collection
      if(this.collection){
        this.collection.trigger("add:element", element, this);
      }
    },
    /**
     * Removes an element from the Section, optionally destroying it
     * If destroy === true, the element is completely removed from the page
     * If destroy === false, the element is being moved to another section
     * @param  {Model} element Element model
     * @param  {boolean} destroy Flag to indicate if the model should be destroyed
     */
    removeElement: function(element, destroy) {
      if (this.elements.contains(element)){
        //notify the element it's been removed
        if (destroy) { element.triggerMethod("remove"); }
        this.stopListening(element);
        this.elements.remove(element);
        // In case we're deleting a form button due its repositioning between containers,
        // we need to avoid re-sorting the form's container. Re-sorting will do the
        // form to re-render and this will lead to the creation of another button, since
        // the removed button is not placed anywhere yet
        if (element.name !== "element:form:button") this.reorderElements();
        if(this.collection){
          this.collection.trigger("remove:element", element, this);
        }
      } else {
        var areas = this.getAreas();
        _.invoke(areas, "removeElement", element, destroy);
      }
    },
    /**
     * Bring an element forward (higher z-index)
     * @param  {Model} element Element model
     */
    moveElementForward: function(element){
      this.elements.moveElementForward(element);
    },
    /**
     * Send an element backward (lower z-index)
     * @param  {Model} element Element model
     */
    moveElementBackward: function(element){
      this.elements.moveElementBackward(element);
    },
    /**
     * Finds an element by its model's NAME
     * @param  {string}  elementName Element model's name
     * @return {Object}             Found element or undefined
     */
    hasElement: function(elementName){
      var element;
      for(var i=0; i < this.elements.length; i++){
        var candidate = this.elements.at(i);

        if(candidate.name === elementName){
          element = candidate;
        }else if(candidate.hasElement){
          element = candidate.hasElement(elementName);
        }
        if (element) break;
      }
      return element;
    },
    getForm: function() {
      return this.elements.reduce(function(form, element){
        return form || (element.name === "element:form"? element : (element.getForm && element.getForm()));
      }, undefined);
    },
    getAreas: function() {
      return this.elements.filter(function(el) { return el.name === "element:area"; });
    },
    /**
     * Checks if an element is contained within section
     * @param  {Model} element Element model
     * @return {boolean}
     */
    contains: function(element){
      return this.elements.contains(element);
    },
    areasContain: function(element) {
      var areas = this.getAreas();
      return _.reduce(areas, function(hasIt, area) {
        return hasIt || area.contains(element);
      }, false);
    },
    /**
     * Iterates the element collection and sets the displayOrder.
     * It also forces the collection to sort
     */
    reorderElements: function(){
      for(var i=0; i < this.elements.length; i++)
      {
        this.elements.at(i).set("displayOrder", i);
      }
      this.elements.sort();
    },
    /**
     * Finds an element Model by its class
     * @param  {class} klass Model class
     * @return {Model}       Element model if found, or undefined
     */
    findElementByClass: function(klass) {
      var areas = this.getAreas();
      return this.elements.find(function(element) {
        return (element instanceof klass);
      }) || _.reduce(areas, function(model, area) {
        return model || area.findElementByClass(klass);
      }, undefined);
    },
    hasSocialElement: function() {
      return this.hasElement("element:social");
    },
    getFBAppId: function() {
      var form = this.hasElement("element:form"),
          element = form && form.hasFacebookLogin();
      return element && element.appId;
    },
    getLinkedInAppId: function() {
      var form = this.hasElement("element:form"),
          element = form && form.hasLinkedInLogin();

      return element && element.appId;
    },
    getGoogleReCaptchaURL: function() {
      var form = this.hasElement("element:form"),
        element = form && form.getGoogleRecaptchaData();

      return element && element.URL;
    },
    getGoogleReCaptchaSiteKey: function() {
      var form = this.hasElement("element:form"),
        element = form && form.getGoogleRecaptchaData();

      return element && element.siteKey;
    },
    hasIBAN: function() {
      var form = this.hasElement("element:form");
      return form && form.hasIBAN();
    },
    getActiveSocialPlugins: function() {
      var elem = this.hasSocialElement();
      return elem && elem.getActivePlugins();
    },
    selfClone: function(options) {
      var newContainer = this.clone(),
          originalGeometry = this.getPropertyGroup(this.geometryProperty);

      /** copies all elements but forms from the original section **/
      this.elements.each(function(el){
        if (options && (el.name.match(options.omit))) return;
        var elCopy = el.selfClone(options);
        newContainer.addElement(elCopy);
      });
      _.each(this.propertyGroups, function(pg){
        var newPg = newContainer.getPropertyGroup(pg.name);
        newPg.set(pg.attributes);
      });
      newContainer.getPropertyGroup("idclass").set("id", "");
      /** sets the same geometry **/
      newContainer.getPropertyGroup(this.geometryProperty).set({
        top: parseInt(originalGeometry.get("top")),
        left: parseInt(originalGeometry.get("left")),
        width: parseInt(originalGeometry.get("width")),
        height: parseInt(originalGeometry.get("height")),
        marginBottom: parseInt(originalGeometry.get("marginBottom"))
      });
      return newContainer;
    },
    /*mixed: function(klass) {
      var proto = klass.prototype;
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        //this.elements = this.elements || new ElementsCollection();
        return init.apply(this, _.rest(arguments));
      });
    }*/
  };
});

